const formatGroup = (group) => {
  switch (group?.toLowerCase()) {
    case "mzo":
      return {
        label: "МЗО",
        bg: "bg-[#674da2]",
        text: "text-white",
        icon: "🎯",
      };
    case "logopedics":
      return {
        label: "Логопедия",
        bg: "bg-[#F3DA6D]",
        text: "text-gray-900",
        icon: "🗣️",
      };
    default:
      return {
        label: group,
        bg: "bg-[#674da2]",
        text: "text-white",
        icon: "📚",
      };
  }
};

export default formatGroup;
